export const getPageCount = (totalItems = 0, itemsPerPage = 20): number => {
  if (itemsPerPage === 0) return 0;
  return Math.ceil(totalItems / itemsPerPage);
};
